// Akry-native formatting helpers (MT, kcal/kg, INR Lakh/Crore, %, etc.)

export const fmtNum = (v, d = 0) => {
  if (v === null || v === undefined || isNaN(v)) return "--";
  return Number(v).toLocaleString("en-IN", { minimumFractionDigits: d, maximumFractionDigits: d });
};

export const fmtMT = (v, d = 0) => `${fmtNum(v, d)}`;

// Indian rupee with smart Lakh / Crore scaling
export const fmtINR = (v) => {
  if (v === null || v === undefined || isNaN(v)) return "--";
  const n = Number(v);
  const abs = Math.abs(n);
  if (abs >= 1e7) return `₹ ${(n / 1e7).toFixed(2)} Cr`;
  if (abs >= 1e5) return `₹ ${(n / 1e5).toFixed(2)} L`;
  if (abs >= 1e3) return `₹ ${(n / 1e3).toFixed(1)} K`;
  return `₹ ${fmtNum(n)}`;
};

export const fmtLakh = (v) => {
  if (v === null || v === undefined || isNaN(v)) return "--";
  return `₹ ${(Number(v) / 1e5).toFixed(1)} L`;
};

export const fmtPct = (v, d = 1) => (v === null || v === undefined || isNaN(v) ? "--" : `${Number(v).toFixed(d)}%`);

export const signPct = (v, d = 1) => {
  if (v === null || v === undefined || isNaN(v)) return "--";
  const s = Number(v) > 0 ? "+" : "";
  return `${s}${Number(v).toFixed(d)}%`;
};

export const signNum = (v, d = 0) => {
  if (v === null || v === undefined || isNaN(v)) return "--";
  const s = Number(v) > 0 ? "+" : "";
  return `${s}${fmtNum(v, d)}`;
};

export const statusColor = (status) => {
  switch (status) {
    case "critical": return "#E63946";
    case "warning": return "#fab20b";
    case "nominal": return "#33b76d";
    default: return "#8BA1C0";
  }
};

export const classColor = (cls) => {
  switch (cls) {
    case "Platinum": return "#9fb6d6";
    case "Gold": return "#fab20b";
    case "Silver": return "#c0c8d4";
    case "Watch": return "#e89b3c";
    case "Restricted": return "#E63946";
    default: return "#8BA1C0";
  }
};
